import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { companiesApi } from '../services/CompaniesService';
import { shareApi } from '../services/DashboardShareService';
import { CompanyStats } from '../responseTypes/company';

interface ICompaniesSlice {
  currentLimit: number | null;
  currentOffset: number | null;
  totalEntities: number | null;
  companiesStats: CompanyStats[];
  currentFromDate: string | null;
  currentToDate: string | null;
}

const initialState: ICompaniesSlice = {
  currentLimit: 20,
  currentOffset: 0,
  totalEntities: null,
  companiesStats: [],
  currentFromDate: null,
  currentToDate: null,
};

const slice = createSlice({
  name: 'companies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      companiesApi.endpoints.getCompaniesStats.matchFulfilled,
      (state: ICompaniesSlice, { payload, meta }) => {
        const { offset, fromDate, toDate } = meta.arg.originalArgs;
        const currentFromDate = fromDate ?? null;
        const currentToDate = toDate ?? null;
        if (offset === 0) {
          return {
            currentLimit: payload.currentLimit,
            currentOffset: payload.currentOffset,
            totalEntities: payload.totalEntities,
            companiesStats: payload.stats,
            currentFromDate,
            currentToDate,
          };
        }
        return {
          currentLimit: payload.currentLimit,
          currentOffset: payload.currentOffset,
          totalEntities: payload.totalEntities,
          companiesStats: [...state.companiesStats, ...payload.stats],
          currentFromDate,
          currentToDate,
        };
      },
    );
    builder.addMatcher(
      shareApi.endpoints.getCompaniesStats.matchFulfilled,
      (state: ICompaniesSlice, { payload, meta }) => {
        const { offset, fromDate, toDate } = meta.arg.originalArgs;
        const currentFromDate = fromDate ?? null;
        const currentToDate = toDate ?? null;
        if (offset === 0) {
          return {
            currentLimit: payload.currentLimit,
            currentOffset: payload.currentOffset,
            totalEntities: payload.totalEntities,
            companiesStats: payload.stats,
            currentFromDate,
            currentToDate,
          };
        }
        return {
          currentLimit: payload.currentLimit,
          currentOffset: payload.currentOffset,
          totalEntities: payload.totalEntities,
          companiesStats: [...state.companiesStats, ...payload.stats],
          currentFromDate,
          currentToDate,
        };
      },
    );
  },
});

export default slice.reducer;

export const selectCompaniesStats = (state: RootState) =>
  state.companies.companiesStats;
export const selectCompaniesStatsPeriod = (state: RootState) => ({
  fromDate: state.companies.currentFromDate,
  toDate: state.companies.currentToDate,
});
export const selectCompaniesTotalEntities = (state: RootState) =>
  state.companies.totalEntities;
export const selectCompaniesHasMore = (state: RootState) => {
  const total = state.companies.totalEntities;
  return (
    total === null ||
    (total > 0 && state.companies.companiesStats.length < total)
  );
};
